export default {
  'pointCard.title': 'บัตรสะสมแต้ม',
  'pointCard.welcome': 'ยินดีต้อนรับเข้าสู่ร่วมกิจกรรมสะสมแต้ม',
  'pointCard.my_card': 'บัตรสะสมแต้มของฉัน',
  'pointCard.all_events': 'กิจกรรมทั้งหมด',
  'pointCard.event_period': 'ระยะเวลากิจกรรม',
  'pointCard.exchange_period': 'ระยะเวลาแลกรางวัล',
  'pointCard.exchange_period.no_limit': 'ระยะเวลาแลกรางวัล ไม่มีวันหมดอายุ',
  'pointCard.exchange_period.date': 'ระยะเวลาแลกรางวัล {date}',
  'pointCard.exchange_period.date_range': 'ระยะเวลาแลกรางวัล {start} ~ {end}',
  'pointCard.exchange_period.points_expired_in_this_month':
    'แต้ม {n} จะหมดอายุในเดือนนี้',
  'pointCard.exchange_period.points_expired_in_this_year':
    'แต้ม {n} จะหมดอายุในปีนี้',
  'pointCard.exchange_period.due_year': '{due} ปี',
  'pointCard.exchange_period.due_month': '{due} เดือน',
  'pointCard.exchange_period.due_day': '{due} วัน',
  'pointCard.exchange_period.3': 'แลกได้ถึงสิ้นปีที่ {due} ถัดไปหลังจากได้รับคะแนน',
  'pointCard.exchange_period.4': 'สามารถแลกได้ภายใน {due} หลังจากได้รับคะแนน',
  'pointCard.exchange_period.5': 'คำนวณระยะเวลาจากครั้งล่าสุดที่ได้รับคะแนน',
  'pointCard.exchange_period.6': 'คำนวณระยะเวลาจากครั้งแรกที่ได้รับคะแนน',
  'pointCard.specified_store': 'ร้านค้าที่ร่วมรายการ',
  'pointCard.join': 'เข้าร่วมกิจกรรม',
  'pointCard.event_end': 'กิจกรรมนี้สิ้นสุดแล้ว',
  'pointCard.add_success': 'เพิ่มบัตรสะสมแต้มสำเร็จ',
  'pointCard.event_deadline': 'วันที่สิ้นสุดกิจกรรม',
  'pointCard.detail': 'รายละเอียด',
} as Record<string, string>;
